import { BrowserRouter, Route, Routes } from "react-router-dom";
import styled from "styled-components";
import Footer from "./components/Footer";
import FooterContainer from "./containers/FooterContainer";
import { Navigation } from "./containers/Navigation";
import { ScrollProvider } from "./contexts/ScrollContextProvider";
import { Contacts } from "./pages/Contacts";
import { Home } from "./pages/Home";
import Photogalery from "./pages/Photogalery";
import Subsidy from "./pages/Subsidy";

const MainContainer = styled.div``;

function App() {
  return (
    <BrowserRouter>
      <MainContainer>
        <ScrollProvider>
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contacts />} />
            <Route path="/photo" element={<Photogalery />} />
            <Route path="/subsidy" element={<Subsidy />} />
          </Routes>

          <FooterContainer>
            <Footer />
          </FooterContainer>
        </ScrollProvider>
      </MainContainer>
    </BrowserRouter>
  );
}

export default App;
